'use strict';

angular.module('contartemx.filtros', [])
  .filter('esMoneda',  ($filter) => {
    return (num) => {
      if (angular.isNumber(num)) {
        if (num < 0) {
          return `(${$filter('currency')(Math.abs(num), '', 2)})`;
        }
        return $filter('currency')(num, '', 2);
      }
      return "0";
    };    
  })
  .filter('moda', () => {
    const mode = (arr) => {
      return arr.sort((a, b) =>
        arr.filter(v => v === a).length
        - arr.filter(v => v === b).length
      ).pop();
    };

    return arr => {
      if (angular.isArray(arr)) {
        return mode(arr);
      }
    };
  });
